module.exports = __webpack_public_path__ + "media/assets/images/flags/sd-52a644252f5f98120684c33b1b008055.svg";